import { useTranslations } from '@i18n/useLanguage'
import { MegaMenuLinks } from '../blocks/common'
import {
  faHouseBuilding,
  faUsers,
  faLocationDot,
  faMapLocationDot,
  faShapes,
  faUserTie,
} from '@fortawesome/pro-solid-svg-icons'
import { MegaMenuGrid } from '../blocks/MegaMenuGrid'

const FindMenu = () => {
  const t = useTranslations().app.nav.megaMenu.findMenu

  return (
    <MegaMenuGrid
      columns={[
        {
          items: [
            {
              to: MegaMenuLinks.discoverInitiatives,
              icon: faHouseBuilding,
              label: t.initiatives.label,
              description: t.initiatives.description,
              backgroundColor: 'var(--shades-pink-200)',
            },
            {
              to: MegaMenuLinks.discoverInitiativesLiving,
              icon: faUsers,
              label: t.livingGroups.label,
              description: t.livingGroups.description,
              backgroundColor: 'var(--shades-yellow-300)',
            },
            {
              to: MegaMenuLinks.discoverPlots,
              icon: faLocationDot,
              label: t.plots.label,
              description: t.plots.description,
              backgroundColor: 'var(--shades-blue-100)',
            },
          ],
        },
        {
          items: [
            {
              to: MegaMenuLinks.regions,
              icon: faMapLocationDot,
              label: t.region.label,
              description: t.region.description,
              backgroundColor: 'var(--shades-red-200)',
            },
            {
              to: MegaMenuLinks.housingForms,
              icon: faShapes,
              label: t.housingForms.label,
              description: t.housingForms.description,
              backgroundColor: 'var(--shades-beige-100)',
            },
            {
              to: MegaMenuLinks.discoverServiceProviders,
              icon: faUserTie,
              label: t.experts.label,
              description: t.experts.description,
              backgroundColor: '#C5F1D0',
            },
          ],
        },
      ]}
    />
  )
}

export default FindMenu
